import { jsx as _jsx } from "react/jsx-runtime";
import { isRecordEmpty } from 'hx-util';
import { useEffect, useRef } from 'react';
export var AudioTrack = function (_a) {
    var track = _a.track;
    var ref = useRef(null);
    useEffect(function () {
        if (!track || isRecordEmpty(track))
            return;
        var el = ref.current;
        track.attach(el);
        return function () {
            track.detach(el);
        };
    }, [track]);
    return _jsx("audio", { ref: ref });
};
